import { useMemo } from "react";
import { ApolloProvider } from "@apollo/client";
import createClient from "@graphql/create_client";

export default function MyApolloProvider({
  apolloCache,
  children,
  requestId,
  sessionId,
  siteId,
  showError,
}) {
  function createApolloClient() {
    const origin = process.env.NEXT_PUBLIC_API_HOST
        ? process.env.NEXT_PUBLIC_API_HOST
        : global.window?.location?.origin || "",
      gqlUri = `${origin}${process.env.NEXT_PUBLIC_API_URL || ""}/${siteId}/d`;

    let apolloClient = global.window?.apolloClient;
    if (!apolloClient) {
      apolloClient = createClient({
        errorHandler: showError,
        extractedCache: apolloCache,
        requestId: requestId,
        sessionId: sessionId,
        siteId: siteId,
        uri: gqlUri,
      });
      if (global.window) global.window.apolloClient = apolloClient;
    }
    return apolloClient;
  }

  const apolloClient = useMemo(() => createApolloClient(), [showError]);

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
}
